import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { TState } from '~/src/store';

const getDescriptionForTariffForNewSubscriptions = (state: TState) => {
    const tariff = selectCurrentTariff(state);
    const {
        selectedSubscriptions,
        subscriptions,
    } = state.fullBuy;

    const result = ['Интернет'];

    if (tariff && !tariff.isMono) {
        result.push('Дом.ru TV');
    }

    if (tariff) {
        tariff.subscriptions?.forEach(item => result.push(item.title));
        selectedSubscriptions.forEach(sId => {
            const title = subscriptions[tariff.sale_package_id].items.find(s => s.serviceId === sId)?.title;
            if (title) {
                result.push(title);
            }
        });
    }

    return result.join(', ');
};

export default getDescriptionForTariffForNewSubscriptions;
